module.exports = __webpack_public_path__ + "img/xaas-support.653412b.png";